import type { NavigationItem } from '../types/navigation.types';
import { CODE_TO_NAME_MAP } from '@/shared/lib/navigation/const';
import { useGenericPathBuilder } from './useGenericPathBuilder';

export interface PathBuilderConfig {
  categoryInfo?: any;
  parentId?: string | null;
  hierarchy?: NavigationItem[];
}

export function useNavigationPathBuilder() {
  const { buildPathWithConfig, shouldNavigate: genericShouldNavigate } = useGenericPathBuilder();

  const buildPath = (item: NavigationItem, config: PathBuilderConfig = {}): string[] => {
    const { hierarchy } = config;

    if (hierarchy) {
      return buildPathWithConfig(item, { hierarchy });
    }

    return [item.code || item.name];
  };

  const shouldNavigate = (item: NavigationItem, hasChildren: boolean): boolean => {
    return genericShouldNavigate(item, hasChildren);
  };

  const getDisplayName = (code: string): string => {
    return CODE_TO_NAME_MAP[code] || code;
  };

  return {
    buildPath,
    shouldNavigate,
    getDisplayName,
    codeToNameMap: CODE_TO_NAME_MAP,
    buildPathWithConfig,
  };
}
